import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {path} from 'ramda';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {changeModalState} from '../../actions/modal'
import {clearObjectToDelete} from '../../actions/objectToDelete'
import './style.css';


class DynamicModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      wrapClassName: 'modal-default',
      size: 'default'
    };

    // this.toggle = this.toggle.bind(this);
    // this.confirm = this.confirm.bind(this);
    // this.save = this.save.bind(this);
  }

  // toggle() {
  //   this.props.handleModalState({
  //     isOpen: !this.props.modal.isOpen
  //   });
  // }

  // confirm() {
  //   // TODO: Remove objectToDelete support
  //   let id = path(['objectToDelete', 'id'], this.props);
  //   let redirect = path(['objectToDelete', 'redirect'], this.props);
  //   let handler = path(['objectToDelete', 'handler'], this.props);
  //   const data = path(['modal', 'data'], this.props) || null;

  //   if (!id && !handler) {
  //     id = path(['modal', 'id'], this.props);
  //     handler = path(['modal', 'handler'], this.props);
  //   }

  //   this.props.makeActionById({
  //     id,
  //     data,
  //     redirect,
  //   }, handler);

  //   this.toggle();
  // }

  // save() {
  //   const id = path(['modal', 'id'], this.props);
  //   const save = path(['modal', 'save'], this.props);
  //   this.props.makeActionById({
  //     id,
  //   }, save);
  // }

  // cancel() {
  //   this.props.clearObjectToRemove({
  //     id: '',
  //     handler: null
  //   });
  //   this.toggle();
  // }

  render() {
    let modalId = path(['modal', 'modalId'], this.props);
    let showModal = this.props.modal.isOpen;
    if (modalId && modalId != this.props.id) {
      showModal = false;
    }

    return (
      <Modal
        isOpen={this.props.show}
        toggle={this.toggle}
        wrapClassName={this.state.wrapClassName}
        size={this.state.size}
      >

        <ModalHeader>{this.props.title}</ModalHeader>
        <ModalBody>
          <div className='d-flex justify-content-center m-10'>{this.props.content}</div>
          <br />
          <div className="action-buttons justify-content-around">
            <button className="btn ui-btn" onClick={this.props.cancelHandler}>
              {this.props.secondary}
            </button>
            <button className="btn btn-success ui-btn" onClick={this.props.confirm}>
              {this.props.primary}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    makeActionById: (data, handler) => {
      if (typeof handler(data) == 'function') {
        handler(data)(dispatch);
      }
    },
    clearObjectToRemove: (data) => {
      dispatch(clearObjectToDelete(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicModal);



// WEBPACK FOOTER //
// ./src/common/Modal/index.js